import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaInstagram,
  FaFacebook,
} from "react-icons/fa";
import CompanyLogo from "../../Assets/Images/company_logo.png";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const userDetails = JSON.parse(localStorage.getItem("user"));

  const type_selfpay = userDetails ? userDetails.is_self_pay : null;
  return (
    <footer className="bwc-footer">
      <div className="footer-content">
        {/* LEFT SECTION */}
        <div className="footer-section">
          <img src={CompanyLogo} alt="Company Logo" className="footer-logo" />

          {/* Phone */}
          <a href="tel:+13472120028" className="footer-row footer-link">
            <FaPhoneAlt className="footer-icon" />
            <span>(347) 212-0028</span>
          </a>

          {/* Email */}
          <a
            href="mailto:becausewecansports@gmail.com"
            className="footer-row footer-link"
          >
            <FaEnvelope className="footer-icon" />
            <span>becausewecansports@gmail.com</span>
          </a>

          <p className="footer-title follow-title">Follow Us on</p>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/bwc_sports/"
            rel="noopener noreferrer"
            className="footer-row link-row footer-link"
          >
            <FaInstagram className="footer-icon" />
            <span>BWC Sports Instagram</span>
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/BecauseWeCanBasketball"
            rel="noopener noreferrer"
            className="footer-row link-row footer-link"
          >
            <FaFacebook className="footer-icon" />
            <span>BWC Sports Facebook</span>
          </a>
        </div>
        <div className="ftr-col-two">
          <h4>QUICK LINKS</h4>
          <div className="ftr-menu-lists">
            {/* QUICK LINKS COLUMN 1 */}
            <div className="footer-section">
              <ul className="footer-links">
                <li>
                  <Link to="/"> Home </Link>
                </li>
                <li>
                  <Link to="/dashboard"> Dashboard </Link>
                </li>
                <li>
                  <Link to="/instruction"> Instruction </Link>
                </li>
                {(type_selfpay === true || type_selfpay === null) && (
                  <li>
                    <Link to="/buy-packages"> Buy Packages </Link>
                  </li>
                )}
                <li>
                  <Link to="/view-all-sessions"> My Sessions </Link>
                </li>
                <li>
                  <Link to="/coaches"> Coaches </Link>
                </li>
              </ul>
            </div>

            {/* QUICK LINKS COLUMN 2 */}
            {/* <div className="footer-section">
                            <ul className="footer-links">
                                <li><Link  to="/field-days"> Field Days </Link></li>
                                <li><Link  to="/school-programs"> School Programs </Link></li>
                                <li><Link  to="/after-school-programs"> After School Programs </Link></li>
                                <li><Link  to="/summer-camp"> Summer Camp </Link></li>
                                <li><Link  to="/birth-day-parties"> Birthday Parties </Link></li>
                                <li><Link  to="/fundraising"> Fundraising </Link></li>
                            </ul>
                        </div> */}

            {/* QUICK LINKS COLUMN 2 */}
            <div className="footer-section">
              <ul className="footer-links">
                <li>
                  <a href="https://summercamp.bwcsports.com">Field Days</a>
                </li>
                <li>
                  <a href="https://summercamp.bwcsports.com">School Programs</a>
                </li>
                <li>
                  <a href="https://summercamp.bwcsports.com">
                    After School Programs
                  </a>
                </li>
                <li>
                  <a href="https://summercamp.bwcsports.com">Summer Camp</a>
                </li>
                {/* <li><a href="https://summercamp.bwcsports.com" >Birthday Parties</a></li> */}
                <li>
                  <a href="https://summercamp.bwcsports.com">Fundraising</a>
                </li>
              </ul>
            </div>

            {/* QUICK LINKS COLUMN 3 */}
            <div className="footer-section">
              <ul className="footer-links">
                <li>
                  <Link to="/login"> Login </Link>
                </li>
                <li>
                  <Link to="/profile"> My Profile </Link>
                </li>
                {(type_selfpay === true || type_selfpay === null) && (
                  <li>
                    <Link to="/cart"> Cart </Link>
                  </li>
                )}
                <li>
                  <Link to="/privacy-policy"> Privacy Policy </Link>
                </li>
                <li>
                  <Link to="/careers"> Careers </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <hr className="ftr-divider" />
      <p className="copyright-text">
        © {new Date().getFullYear()} BWC Sports. All Rights Reserved.
      </p>
      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <p className="black-text-clip">
          (Please Be Advised That All Purchases Are Final. All sales are
          non-refundable and non-transferable)
        </p>
      </div>
    </footer>
  );
};

export default Footer;
